<template>
  <div>
    <table width="100%" class="mb-8">
      <thead>
        <tr>
          <th width="20%" class="text-white font-bold p-[5px] text-sm border-white border-r">Mês</th>
          <th width="40%" class="text-white font-bold p-[5px] text-sm border-white border-r">Envio Equipe</th>
          <th width="30%" class="text-white font-bold p-[5px] text-sm border-white border-r">Envio Meta</th>
          <th width="10%" class="text-white font-bold p-[5px] text-sm border-white">Pontos</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(columns, key) in progress" :key="key">
          <td
            :class="[{ 'border-r': attribute !== 'points' }]"
            v-for="(value, attribute) in columns"
            :key="attribute"
            class="text-white text-center p-[5px] text-sm border-white align-middle"
          >
            <span v-if="['goal', 'team'].includes(attribute)" :class="value ? 'icon-thumb-up' : 'icon-thumb-down'" class="icon-thumb"></span>
            <template v-else>
              {{ value }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="flex py-4 justify-items-stretch sm:flex-col">
        <a @click="showAlert('Selecionar planilha com equipe')" :class="buttonClasses" class="sm:w-full">1. Importar equipe</a>
        <a @click="showAlert('Baixar planilha de metas')" :class="buttonClasses" class="sm:w-full cursor-not-allowed opacity-50">2. Baixar planilha de metas</a>
        <a @click="showAlert('Selecionar planilha de metas')" :class="buttonClasses" class="sm:w-full cursor-not-allowed opacity-50">3. Importar metas</a>
    </div>

    <div>
      <p class="text-white text-sm text-center">Olá embaixador! Faça o upload da sua equipe antes de distribuir as metas.</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      buttonClasses: 'inline-block mb-4 appearance-none select-none py-4 px-12 mx-auto text-xs font-normal text-center text-pink-800 bg-yellow-500 cursor-pointer hover:shadow-sm hover:scale-105 transition-transform ease-in-out rounded-full'
    }
  },
  methods: {
    showAlert(message) {
      window.alert(message)
    }
  }
};
</script>
